import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryDay } from './types';

export function useTimeEntryDayQuery({
	day,
	enabled = true,
	toastOnError = true,
}: {
	day?: string;
	enabled?: boolean;
	toastOnError?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.day(day ?? ''),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryDay>(`TimeEntry/days/${encodeURIComponent(day)}`, 'GET'),
		enabled: enabled && !!day,
		meta: {
			errorLogging: { action: 'TimeEntryDayQuery-Error', category: 'TimeEntry' },
			toastErrorMessage: toastOnError ? 'Failed to load hours for that day' : undefined,
		} satisfies LevStandardQueryMeta,
	});
}
